import { t } from 'modules/i18n'
export default function (text) {
  if (!text) {
    return t('レストラン予約はAutoReserve')
  }
  return `${text} - ${t('AutoReserve')}`
}
